angular.module('Housing').factory('ServiceFundResource', [
    '$resource',
    $resource =>
        $resource(
            '/api/v1/servicefund/:action/:id',
            {},
            {
                getAll: {
                    method: 'GET',
                    isArray: true,
                    params: {}
                },
                getPaged: {
                    method: 'GET',
                    isArray: false,
                    params: { action: 'paged', page: 0, pageSize: 15 }
                },
                getById: {
                    method: 'GET',
                    isArray: false,
                    params: { id: '@id' }
                }
            }
        )
]);
